import { gql } from '@apollo/client'

export const GET_USER_FORM = gql`
	query getUserForm($name: String!) {
		userForm(name: $name) {
			status
			user {
				__typename
			}
			userId
			userQuizzes {
				id
				previousStep
				quiz {
					id
					description
					name
					questionsCount
					quizQuestions {
						id
						name
						question
						questionOptions
						questionType
						requiredNoteIf
						description
					}
					resource {
						__typename
					}
					stepPercentage
					isCompletedStep
				}
				state
				userQuizAnswers {
					answer
					id
					quizQuestionId
					correct
					files {
						file {
							fileUrl
							filename
							byteSize
							blobId
						}
						id
					}
					note
				}
			}
		}
	}
`

/**
 * This query is used to fetch the list of options for a question.
 * Used in `Profile Completion` feature.
 *
 */
export const GET_SELECT_OPTIONS = gql`
	query getSelectOptions($filter: SelectOptionFilter!) {
		selectOptions(filter: $filter) {
			nodes {
				id
				name
			}
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			totalCount
		}
	}
`
